export function prepareNetherlandsBaseLayers(layers, country) {
  if (!['1', 'nl'].includes(String(country).trim().toLowerCase())) return layers;
  const title = layer => String(layer.title || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const source = layer => String(layer.typeName || '').trim().toLowerCase();
  const result = layers.filter(layer =>
    !['region', 'regions'].includes(title(layer))
    && source(layer) !== 'geolinq:u101388viewgroupvbotype1'
  ).map(layer => ({ ...layer }));
  result.forEach(layer => {
    if (['geolinq:nl_4pp', 'geolinq:u101365viewgroupvbotype1'].includes(source(layer))
      || title(layer) === 'pc4') {
      layer.title = 'PC4';
      layer.typeName = 'geolinq:nl_4pp';
    } else if (title(layer) === 'pc6' || source(layer) === 'geolinq:u101373viewgroupvbotype1') {
      layer.title = 'PC6';
      layer.typeName = 'geolinq:nl_6pp';
    }
    if (title(layer) === 'provinces' || source(layer) === 'geolinq:u101379viewgroupvbotype1') {
      layer.typeName = 'geolinq:nl_provinciegebied';
      layer.minResolution = 9;
      layer.maxResolution = 8;
    }
  });
  const municipality = result.find(layer =>
    ['municipalities', 'subregion', 'subregions'].includes(title(layer))
    || ['geolinq:nl_gemeenten', 'geolinq:u101377viewgroupvbotype1'].includes(source(layer)));
  const neighbourhood = result.find(layer =>
    ['neighbourhoods', 'neighborhoods'].includes(title(layer))
    || ['geolinq:nl_buurten', 'geolinq:u101375viewgroupvbotype1'].includes(source(layer)));
  let district = result.find(layer => title(layer) === 'districts'
    || (source(layer) === 'geolinq:nl_wijken' && layer !== municipality && layer !== neighbourhood));
  if (!district) {
    district = {
      title: 'Districts', typeName: 'geolinq:nl_wijken', visible: false,
      minResolution: 13, maxResolution: 11, clustered: false,
      style: neighbourhood?.style || municipality?.style,
      addressCount: null, children: []
    };
    result.push(district);
  }
  district.title = 'Districts';
  district.typeName = 'geolinq:nl_wijken';
  if (municipality) {
    municipality.title = 'Municipalities';
    municipality.typeName = 'geolinq:nl_gemeenten';
  }
  if (neighbourhood) neighbourhood.typeName = 'geolinq:nl_buurten';
  const zoomRanges = {
    municipalities: [9, 11], districts: [11, 13],
    neighbourhoods: [13, 14], neighborhoods: [13, 14],
    pc4: [14, 16], pc6: [16, 18]
  };
  result.forEach(layer => {
    const range = zoomRanges[title(layer)];
    if (range) {
      layer.minResolution = range[1];
      layer.maxResolution = range[0];
    }
  });
  const hierarchy = [
    'addresses', 'pc6', 'pc4', 'neighbourhoods', 'neighborhoods',
    'districts', 'municipalities', 'provinces', 'countries'
  ];
  const rank = layer => {
    const index = hierarchy.indexOf(title(layer));
    return index < 0 ? hierarchy.length : index;
  };
  const ordered = result.sort((a, b) => rank(a) - rank(b));
  return ordered.map((layer, displayOrder) => ({ ...layer, displayOrder }));
}
